import React from 'react'

const cardWrapperStyles = {
    maxWidth: "250px",
    minWidth: "250px",
    padding: "8px",
    marginBottom: "8px",
    marginTop: "8px",
    background: "#fff",
    borderRadius: "5px",
    "-webkit-box-shadow": "0px 5px 5px 0px rgba(0,0,0,0.3)",
    "-moz-box-shadow": "0px 5px 5px 0px rgba(0,0,0,0.3)",
    "-o-box-shadow": "0px 5px 5px 0px rgba(0,0,0,0.3)",
    "box-shadow": "0px 5px 5px 0px rgba(0,0,0,0.3)",
}



export default function Card(props) {
    return (
        <div className="card-wrapper" dragging={props.dragging} style={cardWrapperStyles}>
            {/* <div className="card-title d-flex justify-content-between">
                <h3 style={{fontSize: "1.2rem"}}>{ props.title }</h3>
                <i className="bi bi-x p-2" role="button" tabIndex="0" title={`Remove Card ${props.title}`} onClick={props.removeCard}></i>
            </div> */}
            <div className="card-desc d-flex justify-content-between" style={{fontSize: "1rem"}}>
                { props.title }
                <i className="bi bi-x p-2" role="button" tabIndex="0" title={`Remove Card ${props.title}`} onClick={props.removeCard}></i>
            </div>
        </div>
    )
}
